/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_FoundInputs */

const en_not_found = /** @type {(inputs: Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not found`)
};

const he_not_found = /** @type {(inputs: Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא נמצא`)
};

/**
* | output |
* | --- |
* | "Not found" |
*
* @param {Not_FoundInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const not_found = /** @type {((inputs?: Not_FoundInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_FoundInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_not_found(inputs)
	return he_not_found(inputs)
});